import { Component, ContentChild, Input, TemplateRef } from '@angular/core';

@Component({
  selector: 'show-hide',
  templateUrl: './show-hide.component.html',
  styleUrls: ['./show-hide.component.css'],
})
export class ShowHideSharedComponent {
  @ContentChild('body') body!: TemplateRef<any>;
  @Input() title = 'Insertar título';
  show = true;
  rotate = false;

  hide() {
    this.rotate = !this.rotate;
    this.show = !this.show;
  }
}
